/**
 * 把面板的视觉倾斜角度转成 Cannon-es 世界的重力向量。
 * 面板 Three.js 视觉上绕 X / Z 旋转（tiltX / tiltZ），
 * 但物理世界中面板始终水平 —— 通过把真实世界重力 (0,-g,0) 旋转到
 * 面板的局部坐标系（应用旋转矩阵的逆），球在水平面上就会朝
 * 视觉面板的"低处"滚动。
 *
 * 推导：面板 group rotation 顺序是 Three.js 默认的 intrinsic XYZ，
 * 所以 R_total = R_z * R_x，v_local = R_x^(-1) * R_z^(-1) * v_world。
 * 对 v_world = (0, -g, 0) 展开后得到下方公式。
 *
 * @param {number} tiltX — 绕 X 轴倾斜（弧度）
 * @param {number} tiltZ — 绕 Z 轴倾斜（弧度）
 * @param {number} gravity — 基础重力加速度（正值，通常 9.8）
 * @returns {{ gx: number, gy: number, gz: number }}
 */
export function computeGravityVector(tiltX, tiltZ, gravity) {
  const gx = -gravity * Math.sin(tiltZ);
  const gy = -gravity * Math.cos(tiltX) * Math.cos(tiltZ);
  const gz = gravity * Math.sin(tiltX) * Math.cos(tiltZ);
  return { gx, gy, gz };
}
